var webooker_acivity_models = webooker_acivity_models || {};

(function (ns) {

    // #region RecurringInvoice - Ctor 

    ns.RecurringSchedule = function RecurringSchedule($translate) {

        this.invoice = new ns.RecurringInvoice($translate);
        this.issuedInvoices = [];
    }

    // #endregion

    // #region Reconciliation - Methods

    ns.RecurringSchedule.prototype.getDTO = function ($translate) {
        var res = {
            invoiceRecurrenceScheduleID: this.invoiceRecurrenceScheduleID,
            name: this.name,
            active: this.active,
            activityID: this.activityID,
            studentID: this.studentID,
            semesterID: this.semesterID,
            reccurenceUnitTypeID: this.reccurenceUnitTypeID,
            repeatEveryNoOfUnits: this.repeatEveryNoOfUnits,
            endAfterNoOfIssues: this.endAfterNoOfIssues,
            endAtSpecificDate: this.endAtSpecificDate,
            startDate: this.startDate,
            endDate: this.endDate,
            invoice: this.invoice.getDTO($translate)
        };

        return res;
    }

    ns.RecurringSchedule.prototype.initData = function (dto) {

        this.invoiceRecurrenceScheduleID = dto.invoiceRecurrenceScheduleID;
        this.name = dto.name;
        this.active = dto.active;
        this.activityID = dto.activityID,
        this.studentID = dto.studentID,
        this.semesterID = dto.semesterID,
        this.reccurenceUnitTypeID = dto.reccurenceUnitTypeID;
        this.repeatEveryNoOfUnits = dto.repeatEveryNoOfUnits;
        this.endIssueTypeID = !!dto.endAtSpecificDate ? 1 : 2;
        this.endAfterNoOfIssues = dto.endAfterNoOfIssues;
        this.endAtSpecificDate = dto.endAtSpecificDate;
        this.startDate = dto.startDate;

        this.issuedInvoices = dto.issuedInvoices || [];
        
        this.invoice.initData(dto.invoice);
        this.today = moment().toDate();
    }

    // #endregion

    // #region InvoiceBase - Properties

    Object.defineProperty(ns.RecurringSchedule.prototype, 'notActive', {
        enumerable: true, configurable: true,
        get: function () {
            return !this.active;
        }
    });

    Object.defineProperty(ns.RecurringSchedule.prototype, 'endIssueTypeID', {
        enumerable: true, configurable: true,
        get: function () {
            return this._endIssueTypeID;
        },
        set: function (val) {
            this._endIssueTypeID = val;
            if (val === 1) {
                this._lastEndAfterNoOfIssues = this.endAfterNoOfIssues;
                this.endAfterNoOfIssues = null;
                this.endAtSpecificDate = this._lastEndAtSpecificDate || this.endAtSpecificDate || moment(this.startDate).add(1, 'M').toDate();
            } else {
                this._lastEndAtSpecificDate = this.endAtSpecificDate;
                this.endAtSpecificDate = null;
                this.endAfterNoOfIssues = this._lastEndAfterNoOfIssues || this.endAfterNoOfIssues || 10;
            }
        }
    });

    Object.defineProperty(ns.RecurringSchedule.prototype, 'lastIssuedDate', {
        enumerable: true, configurable: true,
        get: function () {
            var last = _.last(_.sortBy(this.issuedInvoices, 'issuedAt'));
            return !!last
                ? last.issuedAt
                : null;
        }
    });

    Object.defineProperty(ns.RecurringSchedule.prototype, 'endDate', {
        enumerable: true, configurable: true,
        get: function () {
            if (this.endIssueTypeID === 2) { // endAfterNoOfIssues
                switch (this.reccurenceUnitTypeID) {
                    case 1:  // day
                        return moment(this.startDate).add(this.repeatEveryNoOfUnits * Math.max(0, this.endAfterNoOfIssues - 1), 'd').toDate();
                    case 2:  // week
                        return moment(this.startDate).add(this.repeatEveryNoOfUnits * Math.max(0, this.endAfterNoOfIssues - 1), 'w').toDate();
                    case 3:  // month
                        return moment(this.startDate).add(this.repeatEveryNoOfUnits * Math.max(0, this.endAfterNoOfIssues - 1), 'M').toDate();
                }
            }

            // endAtSpecificDate
            return this.endAtSpecificDate;
        }
    });

    Object.defineProperty(ns.RecurringSchedule.prototype, 'nextInvoice', {
        enumerable: true, configurable: true,
        get: function () {

            var lastIssuedDate = this.lastIssuedDate;
            var nextIssueDate = lastIssuedDate || this.startDate;
            var todayIsImportant = moment(this.startDate).isBefore(this.today);
            
            if (!this.repeatEveryNoOfUnits) {
                return null;
            }

            if (!lastIssuedDate) {
                if (moment(this.startDate).isAfter(this.endDate)) {
                    return null;
                }

                if (!todayIsImportant && moment(this.startDate).isSameOrBefore(this.endDate)) {
                    return this.startDate;
                }

                lastIssuedDate = this.startDate;
            }

            if (this.reccurenceUnitTypeID == 3)
            {
                if (moment(lastIssuedDate).date() != moment(this.startDate).date())
                {
                    var lastDayOfMonth = moment(lastIssuedDate).endOf('month').date();
                    var maxDay = Math.min(moment(this.startDate).date(), lastDayOfMonth);

                    lastIssuedDate = moment({
                        year: moment(lastIssuedDate).year(),
                        month: moment(lastIssuedDate).month(),
                        day: maxDay
                    });
                }
            }

            do
            {
                switch (this.reccurenceUnitTypeID) {
                    case 1:  // day
                        nextIssueDate = moment(lastIssuedDate).add(this.repeatEveryNoOfUnits, 'd');
                        break;
                    case 2:  // week
                        nextIssueDate = moment(lastIssuedDate).add(this.repeatEveryNoOfUnits, 'w');
                        break;
                    case 3:  // month
                        nextIssueDate = moment(lastIssuedDate).add(this.repeatEveryNoOfUnits, 'M');
                        if (nextIssueDate.date() < moment(this.startDate).date())
                        {
                            var lastDayOfMonth = moment(nextIssueDate).endOf('month').date();
                            var maxDay = Math.min(moment(this.startDate).date(), lastDayOfMonth);

                            nextIssueDate = moment({ year: nextIssueDate.year(), month: nextIssueDate.month(), day: maxDay });
                        }
                        break;
                }

                lastIssuedDate = nextIssueDate;
            }
            while ((moment(nextIssueDate).isBefore(this.today)) && (moment(this.today).isSameOrBefore(this.endDate)));

            if (moment(nextIssueDate).isAfter(this.endDate) ||
                moment(nextIssueDate).isBefore(this.today) ||
                moment(this.today).isAfter(this.endDate)) {
                return null;
            }

            return nextIssueDate.toDate();
        }
    });

    Object.defineProperty(ns.RecurringSchedule.prototype, 'invoiceTotal', {
        enumerable: true, configurable: true,
        get: function () {            
            return this.invoice.invoiceSumPrice;
        }
    });

    // #endregion

}(webooker_acivity_models));